import { render, staticRenderFns } from "./QuestionnairePhotoConsentsModal.vue?vue&type=template&id=3da8f59c&scoped=true"
import script from "./QuestionnairePhotoConsentsModal.vue?vue&type=script&lang=js"
export * from "./QuestionnairePhotoConsentsModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionnairePhotoConsentsModal.vue?vue&type=style&index=0&id=3da8f59c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da8f59c",
  null
  
)

export default component.exports